import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import EditIcon from "@material-ui/icons/Edit";
import { IconButton, makeStyles } from "@material-ui/core";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

const EDITABLE_FIELDS = [
  "Assessor Name",
  "CDA Review Factor of 100% SDR/SDV Time",
  "Additional Time on Site factor, based on initial risk score",
  "Estimated Activated Non-enrolling Sites",
  'Required "Administrative" IMV for Non-Enrolling Sites',
];

export default function VariablesTable({
  data,
  setEditOpen,
  readOnly,
}) {
  const classes = useIconButtonStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  useRestoreTableVisibility('VariablesTable', setIsExpanded);

  const renderTable = () => {
    return data.map((d, idx) => {
      return (
        <CustomRow key={idx}>
          <CustomCell
            variant="header"
            justify="flex-end"
            width="30%"
            textAlign="right"
            style={{
              borderBottom: "none",
              position: "relative",
              paddingLeft: "20px",
            }}
          >
            {toParticipantUiText(d.rowLabel)}
            {(!readOnly && EDITABLE_FIELDS.includes(d.rowLabel)) && (
              <IconButton
                variant="text"
                color="primary"
                disableRipple
                onClick={() => setEditOpen(true)}
                className={classes.iconButton}
              >
                <EditIcon className={classes.editIcon} />
              </IconButton>
            )}
          </CustomCell>
          <CustomCell width="10%">
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell
            textAlign="left"
            justify="flex-start"
            width="60%"
          >
            <CustomTooltip title={d.notes || ""}>
              <div>{d.notes}</div>
            </CustomTooltip>
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"Variables"}
      defaultExpanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.VARIABLES_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.VARIABLES_TABLE}
        data-table-container="true"
      >
        {renderTable()}
      </Container>
    </Accordion>
  );
}

const useIconButtonStyles = makeStyles(() => ({
  iconButton: {
    position: "absolute",
    left: "5px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "4px",

    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
  },
  editIcon: {
    width: "1rem",
    height: "1rem",
  },
}));
